/**
 * 路由元数据系统 - 模拟Nuxt.js的路由元数据功能
 * 使用方法：
 * import { getRouteMetadata } from '@/utils/route-metadata';
 * const metadata = getRouteMetadata('/goods-list/123');
 */

interface IRouteMeta {
  title?: string;
  description?: string;
  keywords?: string;
}

interface IRouteItem {
  name: string; // 路由名称
  cnName: string; // 中文名称
  component: string; // 组件名称
  auth?: boolean; // 是否需要登录
  meta: IRouteMeta; // 元数据
}

// 路由元数据配置
export const ROUTE_METADATA: Record<string, IRouteItem> = {
  // 首页
  '/': {
    name: 'Home',
    cnName: '首页',
    component: 'HomePage',
    meta: {
      title: 'ZEELOOL - Affordable Prescription Glasses & Stylish Frames',
      description: 'Discover stylish and affordable prescription glasses',
      keywords: 'prescription glasses, eyeglasses, reading glasses',
    },
  },

  // 商品列表页
  '/goods-list/:id': {
    name: 'GoodsList',
    cnName: '商品列表页',
    component: 'GoodsListPage',
    meta: {
      title: 'Product List - ZEELOOL',
      description: 'Browse our collection of stylish glasses',
      keywords: 'glasses, eyewear, frames',
    },
  },

  // 人群推荐列表页
  '/product-list/:id': {
    name: 'CrowdProductList',
    cnName: '人群推荐列表页',
    component: 'CrowdProductListPage',
    meta: {},
  },

  // 商品详情页
  '/goods-detail/:shop_sku': {
    name: 'GoodsDetail',
    cnName: '商品详情页',
    component: 'GoodsDetailPage',
    meta: {
      title: 'Product Detail - ZEELOOL',
      description: 'Product details and specifications',
      keywords: 'product, glasses, detail',
    },
  },

  // 配镜流程-lens
  '/lens-process': {
    name: 'LensProcess',
    cnName: '配镜流程-Select Lenses',
    component: 'LensProcessPage',
    meta: {
      title: 'Lens Process - ZEELOOL',
      description: 'Lens process and specifications',
      keywords: 'lens, process, prescription',
    },
  },
  // 配镜流程-frame
  '/frame-process': {
    name: 'FrameProcess',
    cnName: '配镜流程-Frame Only',
    component: 'FrameProcessPage',
    meta: {
      title: 'Frame Process - ZEELOOL',
      description: 'Frame process and specifications',
      keywords: 'frame, process, prescription',
    },
  },

  // 商品测试页
  '/goods-test': {
    name: 'GoodsTest',
    cnName: '商品详情页',
    component: 'GoodsTestPage',
    meta: {},
  },

  // 购物车
  '/cart': {
    name: 'ShoppingCart',
    cnName: '购物车页',
    component: 'CartPage',
    meta: {
      title: 'Shopping Cart - ZEELOOL',
      description: 'Your shopping cart',
      keywords: 'cart, shopping, checkout',
    },
  },

  // 支付相关
  '/payment': {
    name: 'Payment',
    cnName: '支付页',
    component: 'PaymentPage',
    meta: {},
  },

  '/paymentSuccess': {
    name: 'PaymentSuccess',
    cnName: '支付成功页',
    component: 'PaymentSuccessPage',
    meta: {},
  },

  '/paymentFailed': {
    name: 'PaymentFailed',
    cnName: '支付失败页',
    component: 'PaymentFailedPage',
    meta: {},
  },

  '/waiting-response': {
    name: 'WaitingResponse',
    cnName: '支付结果等待页',
    component: 'WaitingResponsePage',
    meta: {},
  },

  '/waiting-response-pay-center': {
    name: 'WaitingResponsePayCenter',
    cnName: '支付中台支付结果等待页',
    component: 'WaitingResponsePayCenterPage',
    meta: {},
  },

  // 价格差异相关
  '/price-difference': {
    name: 'PriceDifference',
    cnName: '订单补差价页',
    component: 'PriceDifferencePage',
    meta: {},
  },

  '/price-difference-payment-successful': {
    name: 'PriceDifferencePaymentSuccessful',
    cnName: '订单补差价成功页',
    component: 'PriceDifferencePaymentSuccessfulPage',
    meta: {},
  },

  '/price-difference-payment-failed': {
    name: 'PriceDifferencePaymentFailed',
    cnName: '订单补差价失败页',
    component: 'PriceDifferencePaymentFailedPage',
    meta: {},
  },

  // 登录相关
  '/forgot-password': {
    name: 'ForgotPassword',
    cnName: '忘记密码页',
    component: 'ForgotPasswordPage',
    meta: {},
  },

  '/reset-password': {
    name: 'ResetPassword',
    cnName: '重置密码页',
    component: 'ResetPasswordPage',
    meta: {},
  },

  // 搜索相关
  '/search-result': {
    name: 'SearchResult',
    cnName: '搜索列表页',
    component: 'SearchResultPage',
    meta: {},
  },

  '/advance-search': {
    name: 'AdvanceSearch',
    cnName: '高级搜索页',
    component: 'AdvanceSearchPage',
    meta: {},
  },

  // 订单追踪
  '/track-order': {
    name: 'TrackOrder',
    cnName: '订单追踪页',
    component: 'TrackOrderPage',
    meta: {},
  },

  // AR试戴
  '/AR-try-on': {
    name: 'ar',
    cnName: 'AR试戴页',
    component: 'ARTryOnPage',
    meta: {},
  },

  // 活动页面
  '/activity-page': {
    name: 'ActivityPage',
    cnName: '活动页',
    component: 'ActivityPage',
    meta: {},
  },

  '/anniversary-page': {
    name: 'AnniversaryPage',
    cnName: '周年庆活动页',
    component: 'AnniversaryPage',
    meta: {},
  },

  '/black-friday': {
    name: 'BlackFriday2025',
    cnName: '2025黑五活动页',
    component: 'BlackFriday2025Page',
    meta: {},
  },

  '/anniversary-helper': {
    name: 'AnniversaryPageHelper',
    cnName: '周年庆分享页',
    component: 'AnniversaryPageHelperPage',
    meta: {},
  },

  // 专题活动页面
  '/candy-glasses': {
    name: 'CandyGlasses',
    cnName: '糖果专题页',
    component: 'CandyGlassesPage',
    meta: {},
  },

  '/activity/cyberpunk-glasses': {
    name: 'CyberPunkGlasses',
    cnName: '赛博朋克专题页',
    component: 'CyberPunkGlassesPage',
    meta: {},
  },

  '/diva-eyeglasses': {
    name: 'DivaGlasses',
    cnName: '钻石专题页',
    component: 'DivaGlassesPage',
    meta: {},
  },

  '/pink-leopard-glasses': {
    name: 'PinkLeopardGlasses',
    cnName: '粉豹纹专题页',
    component: 'PinkLeopardGlassesPage',
    meta: {},
  },

  '/denim-glasses': {
    name: 'DenimGlasses',
    cnName: '牛仔款专题页',
    component: 'DenimGlassesPage',
    meta: {},
  },

  '/personality-fit-glasses': {
    name: 'PersonalityFitGlasses',
    cnName: '百变女孩专题页',
    component: 'PersonalityFitGlassesPage',
    meta: {},
  },

  '/pearl-glasses': {
    name: 'PearlGlasses',
    cnName: '珍珠女孩专题页',
    component: 'PearlGlassesPage',
    meta: {},
  },

  '/transition-lenses': {
    name: 'TransitionLenses',
    cnName: '全视线专题页',
    component: 'TransitionLensesPage',
    meta: {},
  },

  '/transition-lenses-knowledge': {
    name: 'TransitionTechnology',
    cnName: '全视线知识类专题页',
    component: 'TransitionTechnologyPage',
    meta: {},
  },

  '/fw-2024-eyewear-trends': {
    name: 'FwTrends',
    cnName: '秋季大促专题页',
    component: 'FwTrendsPage',
    meta: {},
  },

  '/blue-light-blocking-glasses': {
    name: 'BlueLightGlasses',
    cnName: '防蓝光知识向专题页',
    component: 'BlueLightGlassesPage',
    meta: {},
  },

  '/driving-glasses': {
    name: 'DrivingGlasses',
    cnName: '驾驶镜知识类专题页',
    component: 'DrivingGlassesPage',
    meta: {},
  },

  '/sparkly-eyeglasses': {
    name: 'SparklyEyeglasses',
    cnName: '2025年1月新品营销专题页',
    component: 'SparklyEyeglassesPage',
    meta: {},
  },

  '/eyeglasses-trends': {
    name: 'EyeglassesTrends',
    cnName: '2025年1月新品营销专题页-活动页',
    component: 'EyeglassesTrendsPage',
    meta: {},
  },

  '/eyeglasses-march-trends': {
    name: 'EyeglassesMarchTrends',
    cnName: '三月趋势活动',
    component: 'EyeglassesMarchTrendsPage',
    meta: {},
  },

  '/festival-glasses': {
    name: 'FestivalGlasses',
    cnName: 'Festival Collection',
    component: 'FestivalGlassesPage',
    meta: {},
  },

  // 大使相关页面
  '/ambassador': {
    name: 'Ambassador',
    cnName: '大使首页',
    component: 'AmbassadorPage',
    meta: {},
  },

  '/ambassador-regist': {
    name: 'AmbassadorRegist',
    cnName: '大使报名页',
    component: 'AmbassadorRegistPage',
    meta: {},
  },

  '/ambassador-list': {
    name: 'AmbassadorList',
    cnName: '大使列表页',
    component: 'AmbassadorListPage',
    meta: {},
  },

  '/ambassador-detail/:id': {
    name: 'AmbassadorDetail',
    cnName: '大使详情页',
    component: 'AmbassadorDetailPage',
    meta: {},
  },

  '/ambassador-work-detail/:id': {
    name: 'AmbassadorDetailWorkDetail',
    cnName: '大使作品详情页',
    component: 'AmbassadorDetailWorkDetailPage',
    meta: {},
  },

  '/trends/:id': {
    name: 'Trends',
    cnName: '趋势活动页',
    component: 'TrendsPage',
    meta: {},
  },

  '/8th-Anniversary-Infinity-Edition': {
    name: 'AnniversaryFreeGifts',
    cnName: '盲盒活动页',
    component: 'AnniversaryFreeGiftsPage',
    meta: {},
  },

  // 镜片专题页
  '/progressive-glasses': {
    name: 'ProgressiveGlasses',
    cnName: '渐进镜专题页',
    component: 'ProgressiveGlassesPage',
    meta: {},
  },

  '/photochromic-glasses': {
    name: 'PhotochromicGlasses',
    cnName: '光致变色专题页',
    component: 'PhotochromicGlassesPage',
    meta: {},
  },

  '/polarized-glasses': {
    name: 'PolarizedGlasses',
    cnName: '偏光镜片专题页',
    component: 'PolarizedGlassesPage',
    meta: {},
  },

  // 公司相关页面
  '/contact-zeelool': {
    name: 'ContactUs',
    cnName: '联系zeelool页',
    component: 'ContactUsPage',
    meta: {},
  },

  '/about-zeelool': {
    name: 'aboutUs',
    cnName: '关于zeelool页',
    component: 'AboutUsPage',
    meta: {},
  },

  '/our-story-zeelool': {
    name: 'ourStory',
    cnName: 'zeelool的故事页',
    component: 'OurStoryPage',
    meta: {},
  },

  '/why-choose-zeelool': {
    name: 'whyChooseZeelool',
    cnName: '为什么选择zeelool页',
    component: 'WhyChooseZeeloolPage',
    meta: {},
  },

  '/zeelool-promise': {
    name: 'zeeloolPromise',
    cnName: 'zeelool的承诺页',
    component: 'ZeeloolPromisePage',
    meta: {},
  },

  '/how-to-order': {
    name: 'howToOrder',
    cnName: '如何下单页',
    component: 'HowToOrderPage',
    meta: {},
  },

  '/affiliate-program': {
    name: 'affiliateProgram',
    cnName: '联盟计划页',
    component: 'AffiliateProgramPage',
    meta: {},
  },

  '/public-welfare': {
    name: 'publicWelfare',
    cnName: '公益活动页',
    component: 'PublicWelfarePage',
    meta: {},
  },

  '/write-for-us': {
    name: 'WriteForUs',
    cnName: '投稿说明页',
    component: 'WriteForUsPage',
    meta: {},
  },

  // 政策页面
  '/student-discount': {
    name: 'studentDiscount',
    cnName: '学生折扣说明页',
    component: 'StudentDiscountPage',
    meta: {},
  },

  '/klarna': {
    name: 'klarna',
    cnName: 'klarna页',
    component: 'KlarnaPage',
    meta: {},
  },

  '/privacy-security': {
    name: 'privacySecurity',
    cnName: '隐私协议页',
    component: 'PrivacySecurityPage',
    meta: {},
  },

  '/return-refund': {
    name: 'returnRefund',
    cnName: '退货退款政策说明页',
    component: 'ReturnRefundPage',
    meta: {},
  },

  '/terms-conditions': {
    name: 'termsConditions',
    cnName: '条款条件页',
    component: 'TermsConditionsPage',
    meta: {},
  },

  '/prescription-verification': {
    name: 'prescriptionVerification',
    cnName: '处方验证说明页',
    component: 'PrescriptionVerificationPage',
    meta: {},
  },

  // 计划页面
  '/influencer-program': {
    name: 'influencerProgram',
    cnName: '影响力计划页',
    component: 'InfluencerProgramPage',
    meta: {},
  },

  '/koc-program': {
    name: 'kocProgram',
    cnName: 'koc计划说明页',
    component: 'KocProgramPage',
    meta: {},
  },

  // 其他页面
  '/buyers-show': {
    name: 'BuyersShow',
    cnName: '买家秀页',
    component: 'BuyersShowPage',
    meta: {},
  },

  '/packaging': {
    name: 'packaging',
    cnName: '包装说明页',
    component: 'PackagingPage',
    meta: {},
  },

  '/guide-tips': {
    name: 'guideTips',
    cnName: '帮助提示页',
    component: 'GuideTipsPage',
    meta: {},
  },

  '/waiting': {
    name: 'Waiting',
    cnName: '验证邮箱中间页',
    component: 'WaitingPage',
    meta: {},
  },

  '/emailDmp': {
    name: 'emailDmp',
    cnName: '营销邮件中间页',
    component: 'EmailDmpPage',
    meta: {},
  },

  '/delete-account': {
    name: 'deleteAccount',
    cnName: '注销账号页',
    component: 'DeleteAccountPage',
    meta: {},
  },

  '/unsubscribe': {
    name: 'Unsubscribe',
    cnName: '退订系统邮件页',
    component: 'UnsubscribePage',
    meta: {},
  },

  '/sms-subscribe': {
    name: 'SmsSubscribe',
    cnName: '手机号订阅页',
    component: 'SmsSubscribePage',
    meta: {},
  },

  '/subscribe-success': {
    name: 'SubscribeSuccess',
    cnName: '订阅成功页',
    component: 'SubscribeSuccessPage',
    meta: {},
  },

  '/recipient': {
    name: 'Recipient',
    cnName: '被分享人落地页',
    component: 'RecipientPage',
    meta: {},
  },

  '/style-hub': {
    name: 'StyleHub',
    cnName: 'style hub独立页',
    component: 'StyleHubPage',
    meta: {},
  },

  '/776d767a2d6dfef576e7f9b344a58731': {
    name: 'StyleHubPreview',
    cnName: 'style hub独立页',
    component: 'StyleHubPreviewPage',
    meta: {},
  },

  '/site-map': {
    name: 'SiteMap',
    cnName: 'site map页',
    component: 'SiteMapPage',
    meta: {},
  },

  // 短链跳转页面
  '/order': {
    name: 'order',
    cnName: 'order短链跳转页',
    component: 'OrderShortLinkPage',
    meta: {},
  },

  '/smsmarket': {
    name: 'smsmarket',
    cnName: 'smsmarket短链跳转页',
    component: 'SmsmarketPage',
    meta: {},
  },

  '/sms': {
    name: 'sms',
    cnName: 'sms短链跳转页',
    component: 'SmsPage',
    meta: {},
  },

  '/fb': {
    name: 'fb',
    cnName: 'fb短链跳转页',
    component: 'FbPage',
    meta: {},
  },

  '/ig': {
    name: 'ig',
    cnName: 'ig短链跳转页',
    component: 'IgPage',
    meta: {},
  },

  '/tw': {
    name: 'tw',
    cnName: 'tw短链跳转页',
    component: 'TwPage',
    meta: {},
  },

  '/ytb': {
    name: 'ytb',
    cnName: 'ytb短链跳转页',
    component: 'YtbPage',
    meta: {},
  },

  '/kol': {
    name: 'kol',
    cnName: 'kol短链跳转页',
    component: 'KolPage',
    meta: {},
  },

  '/tt': {
    name: 'tt',
    cnName: 'tt短链跳转页',
    component: 'TtPage',
    meta: {},
  },

  '/media': {
    name: 'media',
    cnName: 'media短链跳转页',
    component: 'MediaPage',
    meta: {},
  },

  // 账户子页面
  '/account/my-account': {
    name: 'MyAccount',
    cnName: '个人中心首页',
    component: 'MyAccountPage',
    auth: true,
    meta: {},
  },

  '/account/account-settings': {
    name: 'AccountInformation',
    cnName: '账号设置页',
    component: 'AccountSettingsPage',
    auth: true,
    meta: {},
  },

  '/account/account-security': {
    name: 'AccountSecurity',
    cnName: '账号安全设置页',
    component: 'AccountSecurityPage',
    auth: true,
    meta: {},
  },

  '/account/my-orders': {
    name: 'MyOrders',
    cnName: '我的订单页',
    component: 'MyOrdersPage',
    auth: true,
    meta: {},
  },

  '/account/my-orders/order-detail/:id': {
    name: 'OrderDetail',
    cnName: '订单详情页',
    component: 'OrderDetailPage',
    auth: true,
    meta: {},
  },

  '/account/my-coupons': {
    name: 'MyCoupons',
    cnName: '我的优惠券页',
    component: 'MyCouponsPage',
    auth: true,
    meta: {},
  },

  '/account/my-points': {
    name: 'MyPoints',
    cnName: '我的积分页',
    component: 'MyPointsPage',
    auth: true,
    meta: {},
  },

  '/account/points-mall': {
    name: 'PointsMall',
    cnName: '积分商城页',
    component: 'PointsMallPage',
    auth: false,
    meta: {},
  },

  '/account/points-mall-detail/:id': {
    name: 'PointsMallDetail',
    cnName: '积分商城详情页',
    component: 'PointsMallDetailPage',
    auth: false,
    meta: {},
  },

  '/account/my-wallet': {
    name: 'MyWallet',
    cnName: '电子钱包页',
    component: 'MyWalletPage',
    auth: true,
    meta: {},
  },

  '/account/my-card': {
    name: 'MyCard',
    cnName: '我的信用卡',
    component: 'MyCardPage',
    auth: true,
    meta: {},
  },

  '/account/my-wishlist': {
    name: 'MyWishlist',
    cnName: '我的心愿单页',
    component: 'MyWishlistPage',
    auth: true,
    meta: {},
  },

  '/account/refer-a-friend': {
    name: 'ReferAFriend',
    cnName: '邀请好友页',
    component: 'ReferAFriendPage',
    auth: false,
    meta: {},
  },

  '/account/recently-viewed': {
    name: 'RecentlyViewed',
    cnName: '浏览记录页',
    component: 'RecentlyViewedPage',
    auth: true,
    meta: {},
  },

  '/account/koc-program': {
    name: 'KocProgram',
    cnName: 'Koc页',
    component: 'KocProgramPage',
    auth: true,
    meta: {},
  },

  '/account/my-prescriptions': {
    name: 'MyPrescriptions',
    cnName: '我的处方页',
    component: 'MyPrescriptionsPage',
    auth: true,
    meta: {},
  },

  '/account/add-prescription': {
    name: 'AddPrescription',
    cnName: '个人中心添加处方页',
    component: 'AddPrescriptionPage',
    auth: true,
    meta: {},
  },

  '/account/my-address-book': {
    name: 'MyAddressBook',
    cnName: '我的地址页',
    component: 'MyAddressBookPage',
    auth: true,
    meta: {},
  },

  '/account/my-reviews': {
    name: 'MyReviews',
    cnName: '我的评论页',
    component: 'MyReviewsPage',
    auth: true,
    meta: {},
  },

  '/account/write-review': {
    name: 'WriteReview',
    cnName: '订单评论页',
    component: 'WriteReviewPage',
    auth: true,
    meta: {},
  },

  '/account/tickets-history': {
    name: 'TicketsHistory',
    cnName: '历史工单页',
    component: 'TicketsHistoryPage',
    auth: true,
    meta: {},
  },

  '/account/zing': {
    name: 'MyZing',
    cnName: 'Zing会员页',
    component: 'MyZingPage',
    auth: true,
    meta: {},
  },

  '/account/manage-subscription': {
    name: 'ManageSubscription',
    cnName: 'Zing会员订阅管理页',
    component: 'ManageSubscriptionPage',
    auth: true,
    meta: {},
  },

  '/account/zeelool-rewards': {
    name: 'ZeeloolRewards',
    cnName: '会员中心页',
    component: 'ZeeloolRewardsPage',
    auth: false,
    meta: {},
  },

  '/account/zeelool-rewards-desc': {
    name: 'ZeeloolRewardsDesc',
    cnName: '会员中心页说明页',
    component: 'ZeeloolRewardsDescPage',
    auth: false,
    meta: {},
  },

  '/account/communication-preferences': {
    name: 'CommunicationPreferences',
    cnName: '沟通偏好模块',
    component: 'CommunicationPreferencesPage',
    auth: true,
    meta: {},
  },

  '/account/questionnaires-list': {
    name: 'CustomQuestionnaireList',
    cnName: '问卷列表页',
    component: 'CustomQuestionnaireListPage',
    auth: true,
    meta: {},
  },

  '/account/questionnaire-content/:id': {
    name: 'CustomQuestionnaireContent',
    cnName: '问卷详情页',
    component: 'CustomQuestionnaireContentPage',
    auth: true,
    meta: {},
  },

  '/account/question-content/:id': {
    name: 'CustomQuestionnaireContentOld',
    cnName: '问卷详情页',
    component: 'CustomQuestionnaireContentOldPage',
    auth: true,
    meta: {},
  },

  '/account/redeemable-items': {
    name: 'RedeemableItems',
    cnName: '兑换品页',
    component: 'RedeemableItemsPage',
    auth: false,
    meta: {},
  },

  '/account/redeemable-detail/:id': {
    name: 'RedeemableDetail',
    cnName: '兑换品详情页',
    component: 'RedeemableDetailPage',
    auth: false,
    meta: {},
  },

  // 优惠券中心
  '/coupons': {
    name: 'CouponCenter',
    cnName: '领券中心页',
    component: 'CouponCenterPage',
    meta: {},
  },

  // 会员中心独立页
  '/zeelool-rewards': {
    name: 'ZeeloolRewardsActivity',
    cnName: '会员中心独立页',
    component: 'ZeeloolRewardsActivityPage',
    meta: {},
  },

  // 问卷相关
  '/question-break/:id': {
    name: 'QuestionBreak',
    cnName: '问卷详情页-终止',
    component: 'QuestionBreakPage',
    meta: {},
  },

  '/question-complete/:id': {
    name: 'QuestionComplete',
    cnName: '问卷详情页-完成',
    component: 'QuestionCompletePage',
    meta: {},
  },

  // 活动页面
  '/mega-sale0': {
    name: 'MegaSaleZero',
    cnName: '0元购测试页',
    component: 'MegaSaleZeroPage',
    meta: {},
  },

  '/mob-wife-style-glasses': {
    name: 'MobWifeStyleGlasses',
    cnName: '2024 秋冬系列 mob wife 活动页',
    component: 'MobWifeStyleGlassesPage',
    meta: {},
  },

  '/colors-glasses-in-fall-and-winter': {
    name: 'ColorsGlassesInFallAndWinter',
    cnName: '2024 秋冬系列 color fall winter 活动页',
    component: 'ColorsGlassesInFallAndWinterPage',
    meta: {},
  },

  '/old-money-style-glasses': {
    name: 'OldMoneyStyleGlasses',
    cnName: '2024 秋冬系列 old money 活动页',
    component: 'OldMoneyStyleGlassesPage',
    meta: {},
  },

  '/denim-eyeglasses': {
    name: 'DenimEyeglasses',
    cnName: '2024 秋冬系列 denim 活动页',
    component: 'DenimEyeglassesPage',
    meta: {},
  },

  // 博客页面
  '/blog': {
    name: 'Blog2025',
    cnName: '博客页',
    component: 'BlogPage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },

  '/zeelool-blog': {
    name: 'ZeeloolBlogIndexOld',
    cnName: '旧博客页',
    component: 'ZeeloolBlogIndexOldPage',
    meta: {},
  },

  // 博客分类页
  '/blog/:type': {
    name: 'Blog2025Type',
    cnName: '博客分类页',
    component: 'Blog2025TypePage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },
  // 博客文章页
  '/blog/:type/:slug': {
    name: 'Blog2025Article',
    cnName: '博客文章页',
    component: 'Blog2025ArticlePage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },

  // 博客作者列表页
  '/blog/authors': {
    name: 'Blog2025Authors',
    cnName: '博客作者列表页',
    component: 'Blog2025AuthorsPage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },
  // 博客作者详情页
  '/blog/authors/:name': {
    name: 'Blog2025AuthorDetail',
    cnName: '博客作者详情页',
    component: 'Blog2025AuthorDetailPage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },
  // 博客标签页
  '/blog/tags/:tag': {
    name: 'Blog2025Tags',
    cnName: '博客Tag词页',
    component: 'Blog2025TagsPage',
    meta: {
      title: 'Blog - ZEELOOL',
      description: 'Latest news and articles',
      keywords: 'blog, articles, news',
    },
  },

  // 静态页面
  '/fitguide': {
    name: 'FitGuide',
    cnName: '选镜指南页',
    component: 'FitGuidePage',
    meta: {
      title: 'Fit Guide - ZEELOOL',
      description: 'How to find the perfect fit',
      keywords: 'fit guide, sizing, measurement',
    },
  },
  // 静态页面
  '/guide-tips/face-shape': {
    name: 'FaceShape',
    cnName: '面部形状页',
    component: 'FaceShapePage',
    meta: {},
  },

  '/shipping-tracking': {
    name: 'ShippingTracking',
    cnName: '物流跟踪',
    component: 'ShippingTrackingPage',
    meta: {
      title: 'Shipping & Tracking - ZEELOOL',
      description: 'Track your order',
      keywords: 'shipping, tracking, delivery',
    },
  },

  // 特殊路由
  '/4379748524a5a7e2800489f06e198a65/:id': {
    name: 'GoodsListPreview',
    cnName: '商品列表页-魔方预览页',
    component: 'GoodsListPreviewPage',
    meta: {
      title: 'Product List Preview - ZEELOOL',
      description: 'Preview product list',
      keywords: 'preview, product list',
    },
  },

  '/6B05034BB56463ABDBCCEB1A46C81EC7/:id': {
    name: 'CustomQuestionnaireContentPreview',
    cnName: '问卷详情页-魔方预览页',
    component: 'CustomQuestionnaireContentPreviewPage',
    meta: {},
  },

  '/cddabbfc3a131118d33b55258ae3d5df/:id': {
    name: 'GoodsDetailPreview',
    cnName: '商品详情页-魔方预览页',
    component: 'GoodsDetailPreviewPage',
    meta: {},
  },

  // 404页面
  '/404': {
    name: 'NotFound',
    cnName: '页面未找到',
    component: 'NotFoundPage',
    meta: {
      title: 'Page Not Found - ZEELOOL',
      description: 'The page you are looking for does not exist',
      keywords: '404, not found',
    },
  },

  // Pg专题页
  '/zeelool-x-prabal-gurung': {
    name: 'PGPage',
    cnName: 'PG页面',
    component: 'PGPage',
    meta: {},
  },
  // flash sale专题页
  '/flash-sale': {
    name: 'FlashSale',
    cnName: 'flash sale活动页',
    component: 'FlashSalePage',
    meta: {},
  },
  // 春促 flash sale专题页
  '/campaigns/flash-sale': {
    name: 'FlashSale',
    cnName: '202603春促促销会场',
    component: 'FlashSalePage',
    meta: {},
  },
  // 春促 spring sale专题页
  '/campaigns/spring-sale': {
    name: 'SpringSale',
    cnName: '202603春促主会场',
    component: 'SpringSalePage',
    meta: {},
  },
  // 夏季新款镜框预售专题页
  '/campaigns/french-summer-edit-glasses': {
    name: 'FrenchSummerEditGlasses',
    cnName: '2026夏季新款镜框预售',
    component: 'FrenchSummerPage',
    meta: {},
  },
  // 营销专题页（动态路由 campaigns/[slug]）
  '/campaigns/:slug': {
    name: 'CampaignsPage',
    cnName: '营销专题页',
    component: 'CampaignsPage',
    meta: {},
  },
  '/campaigns/sunglasses-sale': {
    name: 'SunglassesSale',
    cnName: '202605太阳镜专题活动页',
    component: 'SunglassesSalePage',
    meta: {},
  },
  '/campaigns/zeelool-x-ulike': {
    name: 'ZeeloolxUlike',
    cnName: '202605Ulike联名活动页',
    component: 'ZeeloolXUlikePage',
    meta: {},
  },
} as const;

// 路由模式匹配
const ROUTE_PATTERNS = [
  { pattern: /^\/goods-list\/(.+)$/, route: '/goods-list/:id' },
  { pattern: /^\/product-list\/(.+)$/, route: '/product-list/:id' },
  { pattern: /^\/goods-detail\/(.+)$/, route: '/goods-detail/:shop_sku' },
  {
    pattern: /^\/account\/my-orders\/order-detail\/(.+)$/,
    route: '/account/my-orders/order-detail/:id',
  },
  { pattern: /^\/account\/points-mall-detail\/(.+)$/, route: '/account/points-mall-detail/:id' },
  {
    pattern: /^\/frame-process$/,
    route: '/frame-process',
  },
  {
    pattern: /^\/lens-process$/,
    route: '/lens-process',
  },
  {
    pattern: /^\/account\/questionnaire-content\/(.+)$/,
    route: '/account/questionnaire-content/:id',
  },
  { pattern: /^\/account\/question-content\/(.+)$/, route: '/account/question-content/:id' },
  { pattern: /^\/account\/redeemable-detail\/(.+)$/, route: '/account/redeemable-detail/:id' },
  { pattern: /^\/ambassador-detail\/(.+)$/, route: '/ambassador-detail/:id' },
  { pattern: /^\/trends\/(.+)$/, route: '/trends/:id' },
  { pattern: /^\/question-break\/(.+)$/, route: '/question-break/:id' },
  { pattern: /^\/question-complete\/(.+)$/, route: '/question-complete/:id' },
  {
    pattern: /^\/4379748524a5a7e2800489f06e198a65\/(.+)$/,
    route: '/4379748524a5a7e2800489f06e198a65/:id',
  },
  {
    pattern: /^\/6B05034BB56463ABDBCCEB1A46C81EC7\/(.+)$/,
    route: '/6B05034BB56463ABDBCCEB1A46C81EC7/:id',
  },
  {
    pattern: /^\/cddabbfc3a131118d33b55258ae3d5df\/(.+)$/,
    route: '/cddabbfc3a131118d33b55258ae3d5df/:id',
  },
  { pattern: /^\/blog\/authors\/(.+)$/, route: '/blog/authors/:name' },
  { pattern: /^\/blog\/tags\/(.+)$/, route: '/blog/tags/:tag' },
  { pattern: /^\/blog\/(.+)\/(.+)$/, route: '/blog/:type/:slug' },
  { pattern: /^\/blog\/(.+)$/, route: '/blog/:type' },
  { pattern: /^\/account\/(.+)$/, route: '/account/:section' },
];

/**
 * 获取路由元数据
 * @param pathname 当前路径
 * @returns 路由元数据
 */
export function getRouteMetadata(pathname: string): IRouteItem | undefined {
  // 去除查询参数，只保留路径部分
  const cleanPathname = pathname.split('?')[0];

  // 直接匹配
  if (ROUTE_METADATA[cleanPathname as keyof typeof ROUTE_METADATA]) {
    return ROUTE_METADATA[cleanPathname as keyof typeof ROUTE_METADATA];
  }

  // 模式匹配
  for (const { pattern, route } of ROUTE_PATTERNS) {
    if (pattern.test(cleanPathname)) {
      return ROUTE_METADATA[route as keyof typeof ROUTE_METADATA];
    }
  }

  // 默认返回404
  return ROUTE_METADATA['/404'];
}

/**
 * 获取路由的中文名称
 * @param pathname 当前路径
 * @returns 中文名称
 */
export function getRouteCnName(pathname: string): string {
  const metadata = getRouteMetadata(pathname);
  return metadata?.cnName || '其他';
}

/**
 * 获取路由的英文名称
 * @param pathname 当前路径
 * @returns 英文名称
 */
export function getRouteName(pathname: string): string {
  const metadata = getRouteMetadata(pathname);
  return metadata?.name || 'Unknown';
}

/**
 * 获取路由的组件名称
 * @param pathname 当前路径
 * @returns 组件名称
 */
export function getRouteComponent(pathname: string): string {
  const metadata = getRouteMetadata(pathname);
  return metadata?.component || 'UnknownComponent';
}

/**
 * 获取路由的SEO元数据
 * @param pathname 当前路径
 * @returns SEO元数据
 */
export function getRouteSeoMeta(pathname: string) {
  const metadata = getRouteMetadata(pathname);
  return metadata?.meta || {};
}

/**
 * 检查是否为特定路由
 * @param pathname 当前路径
 * @param routeName 路由名称
 * @returns 是否匹配
 */
export function isRoute(pathname: string, routeName: string): boolean {
  const metadata = getRouteMetadata(pathname);
  return metadata?.name === routeName;
}

/**
 * 获取所有路由配置
 * @returns 所有路由配置
 */
export function getAllRoutes() {
  return ROUTE_METADATA;
}

/**
 * 根据中文名称查找路由
 * @param cnName 中文名称
 * @returns 路由配置
 */
export function findRouteByCnName(cnName: string) {
  return Object.entries(ROUTE_METADATA).find(([, config]) => config.cnName === cnName);
}

/**
 * 根据组件名称查找路由
 * @param componentName 组件名称
 * @returns 路由配置
 */
export function findRouteByComponent(componentName: string) {
  return Object.entries(ROUTE_METADATA).find(([, config]) => config.component === componentName);
}
